export default "__VITE_ASSET__CzARdx2v__"